<template>
  <v-container>
    <v-card>

      <v-card-title style="color: #B08836"  class="font-weight-bold">
        <h2 class="heading font-weight-bold"> {{formTitle}} Firmantes Para el Acuerdo</h2>
        <v-spacer></v-spacer>
        <v-btn color="#0A4A79" dark to="/panel" small>
          <v-icon small class="mr-5">mdi-arrow-left</v-icon>
          Ir a Panel
        </v-btn>
        <v-btn color="#0A4A79" dark to="/escritos/show" small class="ml-3">
          <v-icon small class="mr-5">mdi-file</v-icon>
          Ir al Escrito
        </v-btn>
      </v-card-title>
      <v-divider inset></v-divider>
      <v-card-text style="color: grey" class="font-weight-black">
        <v-row class="mb-n5">
          <v-col cols="12" md="6">
            <div v-if="currentOrden.sala_id < 12">
              <h4 v-if="currentOrden.numero_completo != 0"><span style="color: darkslategrey">NUM. DE TOCA: {{currentOrden.numero_completo}}</span></h4>
              <h4 v-else ><span style="color: #225882">NUM. DE TOCA: </span> <span style="color: #676767" class="ml-2"><u>En proceso de asignación </u></span><br>
              </h4>
            </div>
            <div  v-if="currentOrden.sala_id == 12">
              <h4 v-if="currentOrden.numero_completo != 0 || currentOrden.sala_id == 12"><span style="color: darkslategrey">NUM. DE ASUNTO: {{currentOrden.numero_completo}}</span></h4>
              <h4 v-else ><span style="color: #225882">NUM. DE ASUNTO: </span> <span style="color: #676767" class="ml-2"><u>En proceso de asignación </u></span><br>
              </h4>
            </div>
            <span class="font-weight-small  mr-3" style="color: #225882">ESTATUS:</span>
                      <u v-if="currentOrden.status==2" style="color: green">Registrada</u>
                      <u v-if="currentOrden.status==3" style="color: green">Contestada</u><br>
          </v-col>
          <v-col cols="12" md="6" class="text-right">
            <span class="font-weight-small black--text mr-3">Abogado:</span><u>{{currentOrden.abogado}}</u><br>
            <span class="font-weight-small black--text mr-3">Email:</span><u>{{currentOrden.abogado_email}}</u><br>
            <!-- <span class="font-weight-small black--text mr-3">Secretario:</span><u>{{currentOrden.juez}}</u><br> -->
            <span class="font-weight-small black--text mr-3">Fecha de envío:</span><u>{{currentOrden.created_at | formatDate}}</u><br>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider inset></v-divider>
      <v-card-text>
        <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col v-if="currentOrden.tipo == 2" cols="12" md="8" align="left">
              <h3 class="font-weight-bold">Seleccione los Magistrados por firmar</h3>
            </v-col>
            <!-- <v-col v-if="currentOrden.tipo == 2" cols="12" md="4" align="right">
              <v-btn v-if="currentOrden.previo_contestacion" small color="blue darken-3" dark @click="getFile()">
                <v-icon small left>mdi-file-document</v-icon>
                ver Acuerdo</v-btn>
            </v-col> -->
          </v-row>
          <br>

          <!-- Multifirma -->

          <v-card v-if="currentOrden.proceso_multifirma == 2">

            <v-alert
              border="top"
              colored-border
              type="success"
              elevation="2"
            >
              ¡La promoción ya ha sido Contestada!
            </v-alert>

          </v-card>

          <v-card v-else>
            <v-list

              shaped
            >
            <v-subheader>
              <!-- <h2 v-if="currentOrden.proceso_multifirma == 0" style="color: #B08836" class="font-weight-bold">Registrar</h2> -->
              <h2 style="color: #B08836" class="font-weight-bold">{{formTitle}}</h2>
              <v-spacer></v-spacer>
              <v-btn v-if="currentOrden.previo_contestacion" small dark color="blue darken-3" @click="getFile()">
                <v-icon small left>mdi-file-document</v-icon>
                ver Acuerdo
              </v-btn>
              <!-- <v-toolbar-title v-if="currentOrden.proceso_multifirma == 0">Registrar</v-toolbar-title>
              <v-toolbar-title v-else>Editar</v-toolbar-title> -->
            </v-subheader>
            <!-- <h3 color="blue" v-if="currentOrden.proceso_multifirma == 0">Registrar</h3>
            <h3 color="blue" v-else>Editar</h3> -->

          </v-list>
            <v-row v-if="!currentOrden.previo_contestacion" class="mt-n1 ml-6">
              <v-col cols="12" md="10" align="center">
                <v-file-input
                  v-model="file"
                  label="Seleccione el Documento del Acuerdo"
                  dense
                  show-size
                  accept="application/pdf"
                  truncate-length="50"
                  :rules="fileRules"
                  @change="fileSelected()"
                ></v-file-input>
              </v-col>
            </v-row>
            <v-row class="mt-n1 ml-6">
              <v-col cols="12" md="10">
                <v-autocomplete
                  v-model="magistrado"
                  :items="listMagistrados"
                  dense
                  @change="addMagistrado()"
                  item-text="nombre"
                  item-value="id"
                  return-object
                  label="Seleccione al Magistrado"
                  prepend-icon="mdi-account"
                  persistent-hint
                  no-data-text="No se Encontraron Magistrados"
                  required
                >
                <template slot="selection" slot-scope="data">
                  <div v-if="data.item.segundo_apellido"class="select-text">
                    {{ data.item.nombre +' '+data.item.primer_apellido +' '+data.item.segundo_apellido}}
                  </div>
                  <div v-else class="select-text">
                    {{ data.item.nombre +' '+data.item.primer_apellido}}
                  </div>
                </template>
                <template slot="item" slot-scope="data">
                  <div v-if="data.item.segundo_apellido"class="select-text">
                    {{ data.item.nombre +' '+data.item.primer_apellido +' '+data.item.segundo_apellido}}
                  </div>
                  <div v-else class="select-text">
                    {{ data.item.nombre +' '+data.item.primer_apellido}}
                  </div>
                </template>
                </v-autocomplete>
              </v-col>
              <!-- <v-col cols="12" md="2">
              <v-btn small color="blue darken-3" dark @click="addMagistrado()">
                <v-icon small left>mdi-plus</v-icon>
                Agregar
              </v-btn>
              </v-col> -->
            </v-row>

            <v-container v-if="magistrados.length > 0">
            <v-card>
              <v-card-title style="color: #B08836"  class="font-weight-bold">
                <h3 class="heading font-weight-bold"> Firmantes del Acuerdo</h3>
              </v-card-title>
              <v-row class="mt-n1">
                <v-col cols="12" md="10">
                  <ul>
                    <li
                      v-for="(magistrado,index) in magistrados"
                      v-bind:key="magistrado.nombre"
                      v-on:remove="magistrados.splice(index, 1)"
                    >
                <h3 v-if="magistrado.segundo_apellido">
                  {{magistrado.nombre+' '+magistrado.primer_apellido+' '+magistrado.segundo_apellido}}
                  <v-btn x-small color="red darken-3" dark @click="removeMagistrado(index)">X</v-btn>
                </h3>
                <h3 v-else>
                  {{magistrado.nombre+' '+magistrado.primer_apellido}}
                  <v-btn x-small color="red darken-3" dark @click="removeMagistrado(index)">X</v-btn>
                </h3>
                <b v-if="magistrado.firmado == 1" style="color: green">Ya ha Firmado</b>
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-card>
          </v-container><br>

          </v-card><br>

          <v-row>
            <v-col cols="12" align="right">
              <v-btn
                v-if="currentOrden.status == 2 && currentOrden.proceso_multifirma == 0"
                tile
                color="success"
                :loading="loading"
                :disabled="!valid"
                @click="validate()"
              >
                <v-icon left>
                  mdi-send
                </v-icon>
                Registrar Firmantes
              </v-btn>
              <v-btn
                v-if="currentOrden.status == 2 && currentOrden.proceso_multifirma == 1"
                tile
                color="success"
                :loading="loading"
                :disabled="!valid"
                @click="editar()"
              >
                <v-icon left>
                  mdi-send
                </v-icon>
                Actualizar Firmantes
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="progress"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="#0A4A79"
        dark
      >
        <v-card-text>
          Cargando Archivo
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";

  export default {
    data(){
      return {
        magistrado:'',
        magistrados: [],
        magistrados_ids: [],
        loading: false,
        progress: false,
        valid: true,
        currentOrden:'',
        files:[],
        file:[],
        url_multifirma:'',
        // nombre_contestacion:'',
        archivo:{
          encode:'',
          type:'application/pdf',
          file_name:''
        },
        archivoDefault:{
          encode:'',
          type:'application/pdf',
          file_name:''
        },
        // sign:true,
        fileRules: [
          value => !value || value.size < 20971520 || 'El documento no debe exceder de 20MB',
          // v => !v || 'El Campo es Requerido',
        ],
      }
    },
    computed: {
      formTitle () {
        if (this.currentOrden.proceso_multifirma === 1) {
          return 'Editar'
        }
        return 'Registrar'
      },
      ...mapGetters(["currentUser", "listMagistrados", "firmasList"]),
    },
    mounted() {
      this.getMagistrados()
      this.currentOrden =  JSON.parse(localStorage.getItem("currentOrden"))
      this.listParafirma()
    },
    methods:{
      listParafirma(){
        if (this.currentOrden.proceso_multifirma == 1) {
          this.getFirmas()
        }
      },

      getFirmas() {
        this.$store.dispatch("GET_FIRMAS",  { url: "/multifirma/"+ this.currentOrden.id +"/firmas" })
          .then(response => {
            // console.log(response.data);
            let firmas = response.data.data.firmas
              firmas.forEach(firma => {
                // this.magistrados.firmado = firma.firmado
                // console.log(firma.firmado);
                firma.magistrado.firmado = firma.firmado
                this.magistrados.push(firma.magistrado)
                this.magistrados_ids.push(firma.magistrado_id)
            });
        })
        .catch(error => {
          console.log(error);
        });
      },

      getMagistrados(){
        this.$store.dispatch("GET_MAGISTRADOS",  { url: "/magistrados" })
          .then(response => {
            // console.log(response.data);
        })
        .catch(error => {
          console.log(error);
        });
      },

      validate() {
        // console.log(this.file);
        if (this.$refs.form.validate()) {
          if (this.file == "" || this.file == null) {
            Swal.fire({
              icon: 'warning',
              title: 'Selecciona un Acuerdo',
              confirmButtonText: "Aceptar",
            })
            this.loading = false
          }
          else if(this.magistrados_ids.length == 0){
            Swal.fire({
              icon: 'warning',
              title: 'Favor de Agregar Magistrados',
              confirmButtonText: "Aceptar",
            })
          } else
          {
            this.loading = true
            this.url_multifirma = "/promocion/"+ this.currentOrden.id +"/multifirma"
            this.saveMultifirma()
          }
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'Favor de verificar los campos Requeridos',
            confirmButtonText: "Aceptar",
          })
        }
      },

      editar() {
          if(this.magistrados_ids.length == 0){
            Swal.fire({
              icon: 'warning',
              title: 'Favor de Agregar Magistrados',
              confirmButtonText: "Aceptar",
            })
          } else
          {
            this.loading = true
            this.url_multifirma = "/promocion/"+ this.currentOrden.id +"/multifirma"
            this.editMultifirma()
          }
      },

      saveMultifirma() {
        this.FilesToUpload()
        const data = {
          magistrados: this.magistrados_ids,
          file: this.archivo
          // nombre: this.nombre_contestacion
        }
        this.$store.dispatch("CREATE_MULTIFIRMA",  { url: this.url_multifirma, data: data })
        .then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Acuerdo y Firmantes Registrados con Éxito',
            timer: 1500,
          })
          this.loading = false
          this.showPromocion()
          // this.close();
          // this.$router.push('/escritos/show')
        })
          .catch(error => {
            this.loading = false
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.response.data.message,
              confirmButtonText: "Aceptar"
            });
            // this.close();
          });
      },
      showPromocion(){
        this.$store.dispatch("SHOW_PROMOCION", {
          url:"/promocion/"+ this.currentOrden.id,
        } )
        .then((response) => {
        this.$router.push('/escritos/show' )
        })
        .catch(err => {
          console.log(err);
        });
      },
      editMultifirma() {
        const data = {
          magistrados: this.magistrados_ids
        }
        this.$store.dispatch("EDIT_MULTIFIRMA",  { url: this.url_multifirma, data: data })
        .then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Firmantes Actualizados con Éxito',
            timer: 1500,
          })
          this.loading = false
          // this.close();
          this.$router.push('/escritos/show')
        })
          .catch(error => {
            this.loading = false
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.response.data.message,
              confirmButtonText: "Aceptar"
            });
            // this.close();
          });
      },
      fileSelected(){
        var file = this.file;
        this.getBase64(file).then(data => {
          this.files.push(data);
        });
      },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
          }
        });
      },
      FilesToUpload() {
        if (this.files.length) {
          this.files.forEach(file => {
            var block = file.split(";");
            // Get the content type of the image
            var contentType = block[0].split(":")[1]; // In this case "jpg
            // get the real base64 content of the file
            this.archivo['type'] = contentType
            var realData = block[1].split(",")[1];
            //console.log(realData);
            this.archivo['encode'] = realData
            this.archivo['file_name'] = this.file.name.split(".pdf")[0];
            // console.log(this.archivo.file_name);
          });
        }
      },

      addMagistrado() {
        if (this.magistrado=="") {
          Swal.fire({
            icon: 'warning',
            title: 'No se ha seleccionado Magistrado',
            showConfirmButton: false,
            timer: 1500
          })
        } else if (this.magistrados_ids.includes(this.magistrado.id)) {
          Swal.fire({
            icon: 'warning',
            title: this.magistrado.nombre + ' ya ha sido agregado',
            showConfirmButton: false,
            timer: 1500
          })
          this.magistrado = ''
          // this.$refs.form.reset()
        } else {
          this.magistrados.push(this.magistrado)
          this.magistrados_ids.push(this.magistrado.id)
          this.magistrado = ''
          // this.$refs.form.reset()
        }
      },
      getFile(){
        this.progress = true
        this.$store.dispatch("GET_FILE", { url: "/promocion/"+ this.currentOrden.id +"/previo-multifirma" }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target' ,'_blank');
            document.body.appendChild(link);
            link.click();
            this.progress = false
          })
          .catch(err => {
            console.log(err);
            this.progress = false
          });
      },
      removeMagistrado(index) {
        this.magistrados.splice(index, 1)
        this.magistrados_ids.splice(index, 1)
      },

      close () {
        this.$refs.form.resetValidation()
        this.$refs.form.reset()
        this.archivo = Object.assign({}, this.archivoDefault)
        this.files = []
        this.file = []
      },

    }
  }
</script>
